module.exports = __webpack_public_path__ + "media/images/lp_v6_check12-4b22a1e3987bab71effa1936781e5927.webp";